import React from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import AnalyticChartData from "../../../../../api/AnalyticChartData";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { GraphComponent } from "../GraphComponent";
import { CalculationPercent } from "../CalculationPercent";

const formatSlicePercent = (percent) => Math.round(percent * 1000) / 10;
const MIN_SLICE_LABEL_PERCENT = 0.05;

const renderPieSliceLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  value,
}) => {
  if (!value || !Number.isFinite(percent) || percent < MIN_SLICE_LABEL_PERCENT) {
    return null;
  }

  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      className="pie_slice_label"
      textAnchor="middle"
      dominantBaseline="central"
    >
      {`${formatSlicePercent(percent)}%`}
    </text>
  );
};

export const VerifyCountChart = observer(
  ({ refApp, shiftPress, setScaleGraph, setScaleGraphFlag }) => {
    const slices = toJS(AnalyticChartData.DataSet.SERIALISATION.datasetsCount.slices);
    const isLoaded = stateAnalyticApp.loaded_verify_count;
    const hasData =
      AnalyticChartData.DataSet.SERIALISATION.datasetsCount.data_print.length > 0;

    if (isLoaded && !hasData) {
      return null;
    }

    return (
      <GraphComponent
        setScaleGraph={setScaleGraph}
        setScaleGraphFlag={setScaleGraphFlag}
        refApp={refApp}
        shiftPress={shiftPress}
        title="Сериализация (этикетки) по датам"
        flag_loaded={isLoaded}
        id="verifyCount"
      >
        <div className="graph_item_body_pie">
          <div className="graph_chart_area graph_chart_area_pie">
            <div className="graph_pie_sizer">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={slices}
                    dataKey="value"
                    nameKey="name"
                    outerRadius="90%"
                    label={renderPieSliceLabel}
                    labelLine={false}
                    isAnimationActive={true}
                    animationDuration={300}
                    animationEasing="ease-out"
                  >
                    {slices.map((slice) => (
                      <Cell
                        key={slice.name}
                        fill={slice.fill}
                        stroke={slice.stroke}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
          <CalculationPercent />
        </div>
      </GraphComponent>
    );
  },
);
